import React from 'react';

interface ProcessStepProps {
  /**
   * Step number or identifier
   */
  number: string | number;
  /**
   * Step title
   */
  title: string;
  /**
   * Step description
   */
  description: string;
  /**
   * Optional icon name
   */
  icon?: string;
  /**
   * Optional additional CSS classes
   */
  className?: string;
  /**
   * Whether this is the last step
   */
  isLast?: boolean;
}

/**
 * Component for displaying a single step in a process flow
 */
const ProcessStep: React.FC<ProcessStepProps> = ({
  number,
  title,
  description,
  icon,
  className = '',
  isLast = false,
}) => {
  return (
    <div className={`relative ${className}`}>
      {/* Step number/icon circle */}
      <div className="flex">
        <div className="flex-shrink-0">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary text-white text-xl font-bold">
            {icon ? (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              number
            )}
          </div>
        </div>

        {/* Content */}
        <div className="ml-4">
          <h3 className="text-xl font-semibold mb-2">{title}</h3>
          <p className="text-neutral-600 dark:text-neutral-400">{description}</p>
        </div>
      </div>

      {/* Connecting line to next step (if not the last step) */}
      {!isLast && (
        <div className="absolute left-6 top-12 bottom-0 -ml-px w-0.5 bg-primary/20 hidden md:block" />
      )}
    </div>
  );
};

export default ProcessStep;